import { tw } from '@/utils/tw';

const Image = tw.theme({
  slots: {
    base: 'relative block w-full overflow-hidden',
    group: 'relative flex w-full flex-col gap-y-2',
    captionGroup: 'not-prose block text-body-md',
    caption: '',
    byline: 'whitespace-nowrap text-gray-700',
  },
});

export default Image;
